import AnalysisCategory from 'views/Analysis/AnalysisCategory';
import { AnalysisKinds, ComparisonKinds } from 'views/Analysis/analysisUtils';

// 分析（年代）
function AnalysisAge(props) {
  // 分析情報
  const analysisList = props.quoteList;
  // 選択中の期
  const selectedPeriod = props.selectedPeriod;
  // 分析種別
  const analysisKind = AnalysisKinds.find((x) => x.key == props.analysisKind);
  // 比較種別
  const comparisonKind = ComparisonKinds.find((x) => x.key == props.comparisonKind);

  // 集計項目
  const summaryItems = [
    { key: 'AGE_20', label: '20～30代' },
    { key: 'AGE_40', label: '40-50代' },
    { key: 'AGE_60', label: '60代以上' },
    { key: 'PUBLIC', label: '公共' },
    { key: 'CORP', label: '法人' },
    { key: 'HARUNA', label: 'はるな墓苑' },
  ];

  return (
    <AnalysisCategory
      analysisList={analysisList}
      selectedPeriod={selectedPeriod}
      summaryItems={summaryItems}
      analysisKind={analysisKind}
      comparisonKind={comparisonKind}
      categoryName="年代別"
    />
  );
}
export default AnalysisAge;
